import React from 'react';
export const MetricsTestimonialsSection = () => {
  const metrics = [{
    value: '1.º a 7.º',
    label: 'Grados cubiertos con propuestas adaptadas.'
  }, {
    value: '5 áreas',
    label: 'Contenidos curriculares integrados.'
  }, {
    value: '4 bonos',
    label: 'Recursos adicionales incluidos.'
  }, {
    value: '4,9/5',
    label: 'Calificación de docentes ⭐'
  }];
  return <section className="bg-familia-section py-10 md:py-16 px-4 md:px-6 border-y border-white/5" data-id="element-139">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-140">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-8" data-id="element-141">
          {metrics.map((m, i) => <div key={i} className="text-center bg-familia-card/40 md:bg-transparent rounded-xl p-4 md:p-0" data-id="element-142">
              <div className="text-3xl sm:text-4xl md:text-5xl font-display font-extrabold mb-2 md:mb-3 text-familia-electric" data-id="element-143">
                {m.value}
              </div>
              <div className="text-[13px] sm:text-sm text-white/85 font-medium leading-tight" data-id="element-144">
                {m.label}
              </div>
            </div>)}
        </div>
        <div className="text-center text-familia-gray text-sm font-medium" data-id="element-145">
          Más de 500 docentes y compradores ya eligieron nuestros materiales.
        </div>
      </div>
    </section>;
};